import { getMSEndpointFromLS } from 'reducers/installer';

const defaultPCEfposUrl = 'https://localhost.erply.com:10105/api/v1/';

export const getEftposUrl = () => {
  const endpoint = getMSEndpointFromLS('pcEftpos');
  return endpoint ? `${endpoint}api/v1/` : defaultPCEfposUrl;
};
